import { CssBaseline } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import Loading from './components/Loading';
import Home from './containers/Home';
import Login from './containers/Login';
import PageNotFound from './containers/PageNotFound';
import { auth } from './firebase/firebase';
import { loginSuccess, logout, relogin } from './store/actions/auth';
import { AuthState } from './store/reducers/auth';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

interface RootState {
  auth: AuthState;
}

const App = () => {
  const dispatch = useDispatch();
  const isLogin = useSelector((state: RootState) => state.auth.isLogin);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    auth.onAuthStateChanged(async (authUser) => {
      if (authUser == null) {
        await dispatch(logout());
      } else {
        await dispatch(relogin(authUser.email!!, authUser.uid));
      }
      setLoading(false);
    });
  }, [isLogin, dispatch]);

  let route = (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Switch>
        <Route path="/" component={Home} />
        <Route path="*" component={PageNotFound} />
        <Redirect to="/" exact />
      </Switch>
    </MuiPickersUtilsProvider>
  );

  if (!isLogin) {
    route = (
      <Switch>
        <Route path="/login" component={Login} />
        <Redirect to="/login" />
      </Switch>
    );
  }

  return (
    <>
      <CssBaseline />
      {loading ? <Loading isLoading={loading} /> : route}
    </>
  );
};

export default App;
